/*eslint-disable */
const $ = window.jQuery = require('jquery');

import VueHtml2pdf from 'vue-html2pdf'
import {
  bus
} from '@/main';

export default {
  name: 'notes-convert-to-pdf',
  components: {
    VueHtml2pdf
  },
  props: ['notesConvertPdfDATA'],
  data () {
    return {
      progressBarEnabled:true,
      progress: 10,
    }
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin:[10, 0, 10, 0],
        filename:this.notesConvertPdfDATA.title,
        enableLinks:true,
        image: { type: "jpeg", quality: 1 },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 4, useCORS: true, dpi: 192, letterRendering: true }
      };
    },
  },
  mounted () {
    this.generateReport()
  },
  methods: {
    /* Generate Report using refs and calling the
        refs function generatePdf()
    */
    generateReport(){
      this.$refs.html2Pdf.generatePdf()
    },
    onProgress(progress) {
      this.progress = progress;
      // console.log(`PDF generation progress: ${progress}%`)
      if(this.progress == '100'){
        setTimeout(()=>{
          bus.$emit('notesConvertPdfStateBus', false);
          $('body').removeClass('notes_converted_pdf_preview_body');
          this.progressBarEnabled = false
        },3000)
      }
    },
    hasStartedGeneration(ev){
      // console.log(ev, "startPagination Option")
    },
    hasGenerated(ev){
      // console.log(ev, "hasPaginated Option")
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
          await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i)
                pdf.setFontSize(12)
                pdf.setTextColor(159,3,3)
                pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 48, pdf.internal.pageSize.getHeight() - 5)
                pdf.text('www.lymphomap.ai', 22, pdf.internal.pageSize.getHeight() - 5)
              } 
        }).save()
    }
  }
}